import {useDispatch, useSelector} from 'react-redux';
import {Button} from 'react-bootstrap';
import {hideLoading, showLoading} from 'stores/actions/appStateAction';
import {alignXYZ, getCurrentPosition} from 'stores/business/instrumentBusiness';
import {setManualReteachCurrentPosition, setMoveMotionControl} from 'stores/actions/reteachPlateAction';
import {manualReteachErrorHandler} from 'stores/business/errorHandlers/manualReteachErrorHandler';
import {useIntl} from 'react-intl';
import {useMemo} from 'react';
import MotionControlPad from '../MotionControlPad';

function MotionControlManualPlateContainer() {
  const dispatch = useDispatch();
  const intl = useIntl();
  const {manualReteachPlate} = useSelector((state) => state.reteachPlateState);
  const {currentPosition} = manualReteachPlate;
  const startingPosition = useMemo(() => currentPosition, [currentPosition]);
  const getCurrPosition = async () => {
    const response = await dispatch(getCurrentPosition());
    dispatch(setManualReteachCurrentPosition(response));
  };

  const onClickArrow = () => {
    dispatch(setMoveMotionControl());
    getCurrPosition();
  };

  const onResetPositionHandler = async () => {
    const {x, y, z} = startingPosition;
    dispatch(showLoading('Reset head position'));
    await dispatch(alignXYZ(x, y, z));
    getCurrPosition();
    dispatch(hideLoading());
  };

  const onErrorHandler = (errCode) => {
    dispatch(manualReteachErrorHandler(errCode));
  };

  return (
    <div className="motion-control-pad">
      <div id="motion-guidance">
        <div className="motion-guidance-header">
          <div className="section-title bordered">
            {intl.formatMessage({id: 'plateTypeEditorContainer.motionControl.title'})}
          </div>
        </div>
        <div className="motion-guidance-content">
          <div className="motion-guidance-content__control-pad">
            <MotionControlPad
              moveValue={0.5}
              style={{marginBottom: '10px'}}
              onClickArrow={onClickArrow}
              withExtendedTouchProbe={false}
              useDefaultErrorHandler={false}
              onHandleError={onErrorHandler}
            />
          </div>
          <div className="motion-guidance-content__reset-button">
            <Button
              type="button"
              bsStyle="primary"
              className="motion-guidance-content__button"
              onClick={onResetPositionHandler}
            >
              {intl.formatMessage({id: 'plateTypeEditorContainer.motionControl.resetButton'})}
            </Button>
          </div>
          <div className="motion-guidance-content__position">
            <span>
              X position :{' '}
              <span className="val-pos" style={{color: currentPosition.x >= 0 ? '#3F9243' : '#FF0000'}}>
                {currentPosition.x}
              </span>
            </span>
            <span>
              Y position :{' '}
              <span className="val-pos" style={{color: currentPosition.y >= 0 ? '#3F9243' : '#FF0000'}}>
                {currentPosition.y}
              </span>
            </span>
            <span>
              Z position :{' '}
              <span className="val-pos" style={{color: currentPosition.z >= 0 ? '#3F9243' : '#FF0000'}}>
                {currentPosition.z}
              </span>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MotionControlManualPlateContainer;
